import { t } from "@/i18n-js/instance";
import { BigLoader } from "@circle-react-shared/BigLoader";
import { Modal } from "@circle-react-uikit/ModalV2";
import { I18N_LOCALE_ROOT } from "./constants";

export const LoadingState = () => (
  <Modal.Body>
    <div className="my-28">
      <BigLoader
        title={t(`${I18N_LOCALE_ROOT}.loading.title`)}
        subtitle={t(`${I18N_LOCALE_ROOT}.loading.subtitle`)}
      />
    </div>
  </Modal.Body>
);
